<template>
  <div>
    <div>
      <!-- item list -->
      <div class="grid gap-6 grid-cols-2 md:grid-cols-4 mb-8 lg:mb-24 min-h-110">
        <div v-if="!loading && items.length === 0" v-html="noResultText" />

        <article v-for="(item) in items"
                 :key="item.id"
                 class="mb-8 c-products-grid"
        >
          <a
            :href="item.url"
            class="block text-center item-link"
          >
            <Picture
              v-bind="item.image"
              lazy
              class="item-picture relative block h-0 pt-full bg-white rounded-full transition-transform duration-150 ease-out"
              img-class="absolute top-0 left-0 w-full h-full object-contain p-6"
              width="375"
              height="391"
            />

            <div class="relative text-center">
              <span class="lg:text-xl md:text-s">{{ item.name }}</span>
            </div>

          </a>
          <AdimoButton
            v-if="item.adimoButton"
            :model="item.adimoButton"
          />
        </article>
      </div>

      <!-- Search more -->
      <div
        v-if="!loading && !allItemsLoaded"
        class="text-center"
      >
        <button
          class="btn-blue md:hidden btn btn-sm"
          @click="searchMore"
        >
          {{ loadMoreButtonText }}
        </button>
        <button
          class="btn-blue hidden md:inline-block btn"
          @click="searchMore"
        >
          {{ loadMoreButtonText }}
        </button>
      </div>
    </div>

    <!-- Loader -->
    <div v-if="loading" class="text-center">
      <div class="spinner spinner-lg spinner-bg-primary-light" />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'

import Picture from '@/components/Picture.vue'
import searchFactory from '@/compositions/search/SearchFactory'
import searchConfig from '@/compositions/search/SearchConfiguration'
import AdimoButton from '@/components/AdimoButton.vue'

export default {
  components: {
    Picture,
    AdimoButton
  },
  setup() {
    const { getActiveConfig } = searchConfig.searchConfigurationUse()
    const {
      items, totalCount, searchMore, loading, allItemsLoaded
    } = searchFactory.useSearchResult()

    return {
      allItemsLoaded,
      loading,
      items,
      searchMore,
      totalCount,
      noResultText: computed(() => getActiveConfig().translations.noResultHtml),
      loadMoreButtonText: computed(() => getActiveConfig().translations.loadMoreButtonText)
    }
  }
}
</script>
